import React from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { Modal } from "components";
import { getUserTimezone, useParams } from "duck";
import { useExportDentalReportMutation } from "requests";

const Export: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { id: caseId } = useParams();
  const [exportReport] = useExportDentalReportMutation();

  const exportOnEmail = (recipientEmail: string) =>
    exportReport({
      variables: {
        input: {
          medicalCase: +caseId,
          recipientEmail,
          userTimezone: getUserTimezone()
        }
      }
    });

  return (
    <>
      <Button onClick={onOpen} colorScheme="minor">
        Export
      </Button>
      <Modal.Export
        isOpen={isOpen}
        onClose={onClose}
        title="Dental Report Export"
        description="Please provide the email address to which you want to export the dental report data."
        onExport={exportOnEmail}
      />
    </>
  );
};

export default Export;
